module.exports = __webpack_public_path__ + "img/802-0a4f4f.png";